<footer class="pt-2 pt-md-5">
    <div class="row">
      <div class="col-12 col-md px-lg-5">
        <img class="mb-2" src="../../../assets/icon.png" alt=""  height="24">
        <p class="text-muted">EBI © 2017-2019</p>
      </div>
      <div class="col-6 col-md">
        <h5>Company</h5>
        <ul class="list-unstyled text-small">
          <li><a class="text-muted" href="http://www.exactblue.com">exactblue.com</a></li>
        </ul>
      </div>
      <div class="col-6 col-md">
        <h5>Resources</h5>
        <ul class="list-unstyled text-small">
          <li><a class="text-muted" href="https://exactblue.wistia.com/medias/aggzp7f1lp">Step by step testing video</a></li>
        </ul>
      </div>
      <div class="col-6 col-md">
        <h5>Legal</h5>
        <ul class="list-unstyled text-small">
          <li><a class="text-muted" href="http://www.exactblue.com/privacy">Privacy</a></li>
          <li><a class="text-muted" href="http://www.exactblue.com/tos">Terms</a></li>
        </ul>
      </div>
    </div>
  </footer>
